import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../logo.png";
import fotoAgente from "../../foto.jpg";

const FUENTE_DESTACADA = "'Outfit', system-ui, sans-serif";

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false
  );
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return isMobile;
}

export default function SobreNosotros() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const dots = {
    backgroundImage: "radial-gradient(circle, rgba(255,255,255,0.25) 1.6px, transparent 1.6px)",
    backgroundSize: "14px 14px",
  };

  return (
    <div style={{
      minHeight: "100vh",
      fontFamily: "system-ui, sans-serif",
      background: "#f5f5f3",
      display: "flex",
      flexDirection: "column",
    }}>

      {/* ── NAVBAR ── */}
      <nav style={{
        background: "#fff",
        borderBottom: "1px solid #e5e7eb",
        padding: isMobile ? "0 16px" : "0 48px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: isMobile ? "60px" : "72px",
        position: "sticky",
        top: 0,
        zIndex: 100,
        boxShadow: "0 1px 6px rgba(0,0,0,0.06)",
      }}>
        <img
          src={logo}
          alt="Confalonieri Propiedades"
          onClick={() => navigate("/")}
          style={{
            height: isMobile ? "36px" : "44px",
            cursor: "pointer",
          }}
        />
        <button
          onClick={() => navigate("/")}
          style={{
            background: "none",
            border: "1px solid #d1d5db",
            borderRadius: "8px",
            color: "#6b7280",
            fontSize: "12px",
            fontWeight: "600",
            letterSpacing: "0.5px",
            padding: "8px 16px",
            cursor: "pointer",
            fontFamily: FUENTE_DESTACADA,
            textTransform: "uppercase",
            transition: "all 0.2s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = "#1a9e2a";
            e.currentTarget.style.color = "#1a9e2a";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = "#d1d5db";
            e.currentTarget.style.color = "#6b7280";
          }}
        >
          ← Inicio
        </button>
      </nav>

      {/* ── HERO VERDE COMPLETO ── */}
      <section style={{
        background: "#1a9e2a",
        position: "relative",
        overflow: "hidden",
        minHeight: isMobile ? "auto" : "520px",
        display: "flex",
        alignItems: "stretch",
      }}>
        <div style={{ ...dots, position: "absolute", inset: 0, zIndex: 0, pointerEvents: "none" }} />

        {!isMobile && (
          <div style={{
            position: "absolute",
            top: 0, bottom: 0,
            right: "38%",
            width: "3px",
            background: "rgba(255,255,255,0.12)",
            transform: "skewX(-8deg)",
            zIndex: 1,
          }} />
        )}

        <div style={{
          position: "relative",
          zIndex: 2,
          width: "100%",
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1fr 420px",
          alignItems: "stretch",
        }}>

          {/* TEXTO — izquierda */}
          <div style={{
            padding: isMobile ? "48px 24px 36px" : "72px 64px 72px 56px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}>
            <p style={{
              fontSize: "11px",
              fontWeight: "700",
              letterSpacing: "4px",
              textTransform: "uppercase",
              color: "rgba(255,255,255,0.6)",
              marginBottom: "16px",
              fontFamily: FUENTE_DESTACADA,
            }}>
              Chajarí · Entre Ríos · Argentina
            </p>

            <h1 style={{
              fontSize: isMobile ? "38px" : "58px",
              fontWeight: "900",
              color: "#fff",
              lineHeight: 1.0,
              letterSpacing: "-1.5px",
              fontFamily: FUENTE_DESTACADA,
              textTransform: "uppercase",
              marginBottom: "8px",
            }}>
              Emmanuel
            </h1>
            <h1 style={{
              fontSize: isMobile ? "38px" : "58px",
              fontWeight: "900",
              color: "rgba(255,255,255,0.25)",
              lineHeight: 1.0,
              letterSpacing: "-1.5px",
              fontFamily: FUENTE_DESTACADA,
              textTransform: "uppercase",
              marginBottom: "28px",
            }}>
              Confalonieri
            </h1>

            <div style={{ width: "56px", height: "3px", background: "#fff", marginBottom: "28px", borderRadius: "2px" }} />

            <p style={{
              fontSize: isMobile ? "15px" : "17px",
              color: "rgba(255,255,255,0.85)",
              lineHeight: 1.75,
              fontFamily: "Georgia, serif",
              fontStyle: "italic",
              maxWidth: "480px",
              marginBottom: "40px",
            }}>
              Asesor inmobiliario dedicado a acompañarte en cada paso de la compra o venta de tu propiedad, con transparencia y compromiso real.
            </p>

            <div style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              background: "rgba(0,0,0,0.18)",
              border: "1px solid rgba(255,255,255,0.2)",
              borderRadius: "100px",
              padding: "10px 20px",
              width: "fit-content",
            }}>
              <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#fff", flexShrink: 0 }} />
              <span style={{
                fontSize: "12px",
                fontWeight: "700",
                color: "rgba(255,255,255,0.9)",
                letterSpacing: "1px",
                textTransform: "uppercase",
                fontFamily: FUENTE_DESTACADA,
              }}>
                Corredor Inmobiliario Matriculado
              </span>
            </div>
          </div>

          {/* FOTO AGENTE — derecha */}
          <div style={{
            position: "relative",
            overflow: "hidden",
            height: isMobile ? "320px" : "auto",
            background: "rgba(0,0,0,0.1)",
          }}>
            <img
              src={fotoAgente}
              alt="Emmanuel J. Confalonieri"
              style={{
                position: "absolute",
                bottom: 0,
                left: "50%",
                transform: "translateX(-50%)",
                height: "100%",
                width: "auto",
                objectFit: "cover",
                objectPosition: "top center",
              }}
            />
            {!isMobile && (
              <div style={{
                position: "absolute",
                top: 0, left: 0, bottom: 0,
                width: "80px",
                background: "linear-gradient(to right, #1a9e2a, transparent)",
                zIndex: 1,
              }} />
            )}
          </div>

        </div>
      </section>

      {/* ── STRIP OSCURO ── */}
      <div style={{
        background: "#111827",
        padding: isMobile ? "24px 24px" : "28px 56px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
        <p style={{
          fontSize: isMobile ? "14px" : "17px",
          color: "rgba(255,255,255,0.85)",
          fontFamily: "Georgia, serif",
          fontStyle: "italic",
          textAlign: "center",
          letterSpacing: "0.3px",
          lineHeight: 1.4,
        }}>
          Su confianza es nuestra prioridad y su satisfacción nuestro compromiso
        </p>
      </div>

      {/* ── SECCIÓN NOSOTROS — LAYOUT ASIMÉTRICO ── */}
      <section style={{
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "280px 1fr",
        minHeight: isMobile ? "auto" : "380px",
      }}>

        {/* Barra verde lateral */}
        <div style={{
          background: "#1a9e2a",
          padding: isMobile ? "32px 24px" : "56px 40px",
          position: "relative",
          overflow: "hidden",
        }}>
          <div style={{ ...dots, position: "absolute", inset: 0, zIndex: 0 }} />
          <div style={{ position: "relative", zIndex: 1 }}>
            <p style={{
              fontSize: "10px",
              fontWeight: "700",
              letterSpacing: "3px",
              textTransform: "uppercase",
              color: "rgba(255,255,255,0.55)",
              marginBottom: "16px",
              fontFamily: FUENTE_DESTACADA,
            }}>
              Sobre nosotros
            </p>
            <h2 style={{
              fontSize: isMobile ? "22px" : "26px",
              fontWeight: "800",
              color: "#fff",
              lineHeight: 1.15,
              fontFamily: FUENTE_DESTACADA,
              textTransform: "uppercase",
              letterSpacing: "-0.5px",
            }}>
              La empresa
            </h2>
            <div style={{ width: "32px", height: "2px", background: "rgba(255,255,255,0.4)", margin: "20px 0", borderRadius: "2px" }} />
            <p style={{ fontSize: "13px", color: "rgba(255,255,255,0.7)", lineHeight: 1.6, fontFamily: "Georgia, serif", fontStyle: "italic" }}>
              Confalonieri Propiedades
            </p>
          </div>
        </div>

        {/* Texto — derecha */}
        <div style={{
          background: "#fff",
          padding: isMobile ? "36px 24px" : "56px 64px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}>
          <p style={{
            fontSize: isMobile ? "15px" : "16px",
            color: "#374151",
            lineHeight: 1.9,
            fontFamily: "Georgia, serif",
            marginBottom: "24px",
            borderLeft: "3px solid #1a9e2a",
            paddingLeft: "20px",
          }}>
            Oriundo de la ciudad de Chajarí y al frente de <strong style={{ color: "#111827" }}>Confalonieri Propiedades</strong>, un lugar donde nos preocupamos por brindar asesoramiento personalizado en el sector inmobiliario, enfocándonos en las necesidades de cada cliente para poder cumplir con ellas.
          </p>
          <p style={{
            fontSize: isMobile ? "15px" : "16px",
            color: "#374151",
            lineHeight: 1.9,
            fontFamily: "Georgia, serif",
            paddingLeft: isMobile ? "0" : "24px",
          }}>
            Ya sea para la compra o la venta de inmuebles, nos dedicamos a encontrar las mejores opciones garantizando un proceso transparente y eficiente — tanto de manera individual como en conjunto con profesionales locales, ampliando la red de contactos para encontrar mejores oportunidades.
          </p>
        </div>

      </section>

      {/* ── VALORES ── */}
      <section style={{ background: "#f5f5f3", padding: isMobile ? "40px 20px" : "56px 56px" }}>
        <div style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
          gap: "16px",
        }}>
          {[
            { titulo: "Transparencia", texto: "Cada paso del proceso, claro y documentado. Sin sorpresas." },
            { titulo: "Compromiso", texto: "Tu búsqueda es nuestra prioridad hasta encontrar la solución ideal." },
            { titulo: "Red profesional", texto: "Trabajamos junto a profesionales locales para ampliar tus opciones." },
          ].map((v) => (
            <div key={v.titulo} style={{
              background: "#fff",
              borderTop: "3px solid #1a9e2a",
              borderRadius: "0 0 12px 12px",
              padding: "28px 24px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
            }}>
              <h3 style={{
                fontSize: "14px",
                fontWeight: "700",
                color: "#1a9e2a",
                textTransform: "uppercase",
                letterSpacing: "1px",
                marginBottom: "10px",
                fontFamily: FUENTE_DESTACADA,
              }}>
                {v.titulo}
              </h3>
              <p style={{ fontSize: "14px", color: "#6b7280", lineHeight: 1.7, fontFamily: "Georgia, serif" }}>
                {v.texto}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* ── CONTACTO OSCURO ── */}
      <section style={{
        background: "#111827",
        padding: isMobile ? "48px 20px" : "64px 56px",
        position: "relative",
        overflow: "hidden",
      }}>
        <div style={{
          backgroundImage: "radial-gradient(circle, rgba(26,158,42,0.2) 1.6px, transparent 1.6px)",
          backgroundSize: "14px 14px",
          position: "absolute", inset: 0, zIndex: 0,
        }} />

        <div style={{ position: "relative", zIndex: 1 }}>
          <p style={{
            fontSize: "10px",
            fontWeight: "700",
            letterSpacing: "4px",
            textTransform: "uppercase",
            color: "#1a9e2a",
            marginBottom: "8px",
            fontFamily: FUENTE_DESTACADA,
          }}>
            Contacto
          </p>
          <h2 style={{
            fontSize: isMobile ? "28px" : "36px",
            fontWeight: "800",
            color: "#fff",
            fontFamily: FUENTE_DESTACADA,
            textTransform: "uppercase",
            letterSpacing: "-0.5px",
            marginBottom: "40px",
          }}>
            Encontranos
          </h2>

          <div style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
            gap: "16px",
            marginBottom: "36px",
          }}>
            {[
              { icon: "📍", titulo: "Sarmiento 2750", sub: "Chajarí, Entre Ríos", link: null },
              { icon: "📞", titulo: "(03456) 15458348", sub: "WhatsApp disponible", link: "https://wa.me/5493456458348" },
              { icon: "📸", titulo: "@confalonieri.propiedades", sub: "Instagram", link: "https://www.instagram.com/confalonieri.propiedades" },
            ].map((c) => (
              <div
                key={c.titulo}
                onClick={() => c.link && window.open(c.link, "_blank")}
                style={{
                  background: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  borderRadius: "12px",
                  padding: "24px 20px",
                  cursor: c.link ? "pointer" : "default",
                  transition: "border-color 0.2s, background 0.2s",
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                }}
                onMouseEnter={(e) => {
                  if (c.link) {
                    e.currentTarget.style.borderColor = "#1a9e2a";
                    e.currentTarget.style.background = "rgba(26,158,42,0.08)";
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)";
                  e.currentTarget.style.background = "rgba(255,255,255,0.05)";
                }}
              >
                <span style={{ fontSize: "28px", flexShrink: 0 }}>{c.icon}</span>
                <div>
                  <p style={{ fontSize: "13px", fontWeight: "700", color: "#fff", marginBottom: "2px", fontFamily: FUENTE_DESTACADA }}>{c.titulo}</p>
                  <p style={{ fontSize: "11px", color: "rgba(255,255,255,0.4)", fontFamily: FUENTE_DESTACADA }}>{c.sub}</p>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={() => window.open("https://wa.me/5493456458348", "_blank")}
            style={{
              background: "#1a9e2a",
              color: "#fff",
              border: "none",
              borderRadius: "10px",
              padding: "15px 36px",
              fontWeight: "700",
              fontSize: "14px",
              cursor: "pointer",
              fontFamily: FUENTE_DESTACADA,
              letterSpacing: "0.5px",
              textTransform: "uppercase",
              width: isMobile ? "100%" : "auto",
              transition: "opacity 0.2s",
            }}
            onMouseEnter={(e) => e.currentTarget.style.opacity = "0.85"}
            onMouseLeave={(e) => e.currentTarget.style.opacity = "1"}
          >
            💬 Escribinos por WhatsApp
          </button>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer style={{
        borderTop: "3px solid #1a9e2a",
        padding: isMobile ? "14px 16px" : "16px 24px",
        textAlign: "center",
        color: "#9ca3af",
        fontSize: isMobile ? "11px" : "12px",
        background: "#fff",
        lineHeight: 1.4,
      }}>
        © {new Date().getFullYear()} Confalonieri Propiedades · Sarmiento 2750, Chajarí · Todos los derechos reservados
      </footer>

    </div>
  );
}
